var map = {
	"./Abigail Strate_action.jpg": 9220,
	"./Abigail Strate_portrait.jpg": 5457,
	"./Adrian Tittel_action.jpeg": 374,
	"./Adrian Tittel_portrait.jpeg": 5283,
	"./Alina Nußbicker_action.jpeg": 4729,
	"./Alina Nußbicker_portrait.jpeg": 9769,
	"./Amandine Mengin_action.jpeg": 7458,
	"./Amandine Mengin_portrait.jpeg": 4758,
	"./Anna Twardosz_action.jpeg": 2324,
	"./Anna Twardosz_portrait.jpeg": 1577,
	"./Anna-Fay Scharfenberg_action.jpeg": 4976,
	"./Anna-Fay Scharfenberg_portrait.webp": 3773,
	"./Anne Häckel_action.jpg": 2591,
	"./Anne Häckel_portrait.jpg": 1766,
	"./Charlotte Gallbronner_action.jpeg": 9098,
	"./Charlotte Gallbronner_portrait.jpeg": 1984,
	"./Charlotte Grandinger_action.webp": 392,
	"./Charlotte Grandinger_portrait.webp": 9688,
	"./Cindy Haasch_action.jpg": 6680,
	"./Cindy Haasch_portrait.jpg": 302,
	"./David mach_action.jpg": 7952,
	"./David mach_portrait.jpg": 8656,
	"./Emely Torazza_action.jpeg": 4195,
	"./Emely Torazza_portrait.jpeg": 6068,
	"./Emily Teubner_action.JPG": 5027,
	"./Emily Teubner_portrait.JPG": 6602,
	"./Felix Hoffman_action.jpg": 9135,
	"./Felix Hoffman_portrait.jpg": 2228,
	"./Hektor Kapustik_action.jpeg": 3541,
	"./Hektor Kapustik_portrait.jpeg": 6241,
	"./Janina Hettich-Walz_action.JPG": 9863,
	"./Jenny Nowak_action.jpeg": 8253,
	"./Jenny Nowak_portrait.jpeg": 2363,
	"./Jessica Malsiner_action_01.jpg": 8225,
	"./Jessica Malsiner_portrait_.jpg": 5431,
	"./Josephine Pagnier_action.jpeg": 1566,
	"./Josephine Pagnier_portrait.jpeg": 6870,
	"./Julina Kreibich_action.jpg": 9108,
	"./Julina Kreibich_portrait.jpg": 6985,
	"./Karl geiger_action.jpg": 3697,
	"./Kira Kapustikova_action.jpeg": 2351,
	"./Kira Kapustikova_portrait.jpeg": 1768,
	"./Lara Malsiner_action.jpg": 8438,
	"./Lara Malsiner_portrait.jpeg": 3393,
	"./Lia Boehme_action.jpg": 3851,
	"./Lia Boehme_portrait.jpg": 8983,
	"./Louis Obersteiner_action.jpg": 5759,
	"./Louis Obersteiner_portrait.jpeg": 9065,
	"./Luisa Goerlich_action.JPG": 9784,
	"./Luisa Goerlich_portrait.JPG": 7437,
	"./Maria Gerboth_action.jpg": 6629,
	"./Maria Gerboth_portrait.jpg": 7118,
	"./Martin Hamann_action.jpeg": 4745,
	"./Martin Hamann_portrait.jpg": 7716,
	"./Nicole Maurer_action.jpeg": 9053,
	"./Nicole Maurer_portrait.jpeg": 3379,
	"./Richard Stenzel_action.jpg": 5376,
	"./Richard Stenzel_portrait.jpg": 8878,
	"./Robin Kloß_action.jpeg": 1012,
	"./Robin Kloß_portrait.jpeg": 7719,
	"./Ronja Loh_action.jpeg": 3228,
	"./Ronja Loh_portrait.jpeg": 3767,
	"./Simon Mach_action.jpg": 7082,
	"./Simon Mach_portrait.jpg": 6098,
	"./Tristan Sommerfeldt_action.jpg": 6326,
	"./Tristan Sommerfeldt_portrait.jpg": 6791,
	"./eric frenzel_action.jpg": 5180,
	"./hall of fame/Andrea Henkel.jpg": 1966,
	"./hall of fame/Anja Pärson.webp": 5019,
	"./hall of fame/Bernd Schneider.jpeg": 1859,
	"./hall of fame/Björn Kircheisen.jpg": 2091,
	"./hall of fame/Florian Liegl.jpg": 7569,
	"./hall of fame/Frenzel_Eric_portrait_01.jpg": 8286,
	"./hall of fame/Janina Hettich-Walz.JPG": 1015,
	"./hall of fame/Julia Görges.jpg": 8511,
	"./hall of fame/Karl Geiger.jpg": 8015,
	"./hall of fame/Kirsten Flipkens.webp": 6183,
	"./hall of fame/Lars Bender.jpg": 4480,
	"./hall of fame/Lucie Safarova.jpg": 5586,
	"./hall of fame/Magdalena Neuner 2.jpg": 5301,
	"./hall of fame/Mandy Minella.jpeg": 1908,
	"./hall of fame/Martina Ertl.jpg": 2526,
	"./hall of fame/Martina Glagow.jpg": 352,
	"./hall of fame/Martina Zellner.webp": 576,
	"./hall of fame/Nico Hülkenberg.webp": 8442,
	"./hall of fame/Red Bull Toro Rosso.webp": 6008,
	"./hall of fame/Stefan Edberg Tennis Academy.jpeg": 7093,
	"./hall of fame/Stefanie Böhler.jpg": 906,
	"./hall of fame/Susanne Riesch.jpg": 973,
	"./hall of fame/Sven Bender.jpg": 9330,
	"./hall of fame/Sven-Göran Eriksson.jpg": 4560,
	"./portrait_placeholder.jpg": 3218
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4451;